<template lang="html">
    <v-dialog :value="show" persistent scrollable fullscreen transition="scale-transition">
        <v-card class="chart-modal">

            <v-toolbar color="secondary" dark tabs>
                <v-toolbar-title v-text="stationName"></v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- <v-tooltip bottom>
                    <v-btn icon color="primary" slot="activator">
                        <v-icon>view_list</v-icon>
                    </v-btn>
                    <span>View CSV Data</span>
                </v-tooltip> -->

                <v-btn icon @click.native="hide">
                    <v-icon>close</v-icon>
                </v-btn>

                <v-tabs
                    class="tab-switcher"
                    fixed
                    centered
                    color="secondary"
                    slot="extension"
                    v-model="activeTab">

                    <v-tab href="#surface-water-quality">
                        Surface Water Quality
                    </v-tab>

                </v-tabs>

            </v-toolbar>

            <v-tabs-items v-model="activeTab">

                <v-tab-item id="surface-water-quality">
                    <v-card flat>
                        <v-card-text>
                            <div
                                v-if="stationData === null"
                                class="no-data grey lighten-2 grey--text">
                                <span>No data available</span>
                            </div>
                            <div v-else>

                                <sw-quality-table v-if="show && activeTab === 'surface-water-quality'" />

                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-dialog>
</template>

<script>
import * as actions from '@/constants/actions';
import checkData from '@/mixins/checkQueryData';
import surfaceQualityData from '@/mixins/surfaceQualityData';
import SwQualityTable from '@/components/charts/SurfaceQualityTable';

export default {
    name: 'chart-modal',
    components: {
        SwQualityTable,
    },
    mixins: [
        checkData,
        surfaceQualityData,
    ],
    computed: {
        show() {
            return this.$store.state.showChartModal;
        },
        activeTab: {
            get() {
                return this.$store.state.chartModalActiveTab;
            },
            set(val) {
                this.$store.dispatch(actions.SET_CHART_MODAL_TAB, val);
            },
        },
        stationData() {
            return this.queryData;
        },
        stationName() {
            if (this.stationData) {
                return this.stationData.name;
            }
            return '';
        },
    },
    methods: {
        hide() {
            this.$store.dispatch(actions.SHOW_CHART_MODAL, false);
        },
    },
};
</script>

<style scoped lang="scss">
.tab-switcher  {
    display: flex;
    flex-direction: column;
}

.tab-switcher-items {
    overflow-y: auto;
    flex: 1 1 100%;
}

.no-data {
    height: 15rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ChartModalSwQuality.vue